export enum SplashAnimationType {
  SlideLeft = 'SlideLeft',
  SlideRight = 'SlideRight',
  FadeOut = 'FadeOut'
}
